<button class="icon-left" mat-icon-button [matMenuTriggerFor]="dateFilterMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #dateFilterMenu="matMenu">
    <div (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilter()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Reset filter</span>
            </button>
        </div>
        <form [formGroup]="form">
            <div class="datetime-container">
                <div class="datetime-picker">
                    <mat-form-field class="date-input lc-form-field" appearance="outline">
                        <label>From</label>
                        <input matInput formControlName="fromDate" [matDatepicker]="pickerFrom">
                        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFrom></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="time-input lc-form-field" appearance="outline">
                        <input matInput type="time" formControlName="fromTime">
                    </mat-form-field>
                </div>
            </div>
            <div class="datetime-container">
                <div class="datetime-picker">
                    <mat-form-field class="date-input lc-form-field" appearance="outline">
                        <label>To</label>
                        <input matInput formControlName="toDate" [matDatepicker]="pickerTo">
                        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                        <mat-datepicker #pickerTo></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="time-input lc-form-field" appearance="outline">
                        <input matInput type="time" formControlName="toTime">
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="button-container">
            <button mat-stroked-button class="lc-stroked-button-no-margin lc-primary" (click)="applyFilter()"
                [disabled]="!canApplyFilter()">
                <mat-icon svgIcon="tick"></mat-icon> Apply
            </button>
        </div>
    </div>
</mat-menu>